import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import {useState, createContext, useEffect} from 'react';
import { changeDisable, setMaskGeneric, viewItem, parseToFloat, hoursNow, dateToday, setMaskDecimal, setMaskHour, getPermission, showMessageError, handleInput, changeValueOfArrayOfObjects, custom, convertStringValueToBoolean } from '../../../classes/functions';
import './entry.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaPen, FaArrowAltCircleLeft, FaCog, FaTrash } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import ModalConfirmation from '../../../components/Modal/ModalConfirmation/index.js';
import InputDate from '../../../components/Inputs/Date/index.js';
import ModalAuxiliaresData from '../../../components/Modal/ModalAuxiliaresData/index.js';

export default function EntryDocuments(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);
  const [labelButton, setLabelButton] = useState('Adicionar');
  const [emissao, setEmissao] = useState('');
  const [tipo, setTipo] = useState('');
  const [complemento, setComplemento] = useState('');
  const [numero_documento, setNumeroDocumento] = useState('');
  const [serie_documento, setSerieDocumento] = useState('');
  const [especie_documento, setEspecieDocumento] = useState('');
  const [hora_entrada, setHoraEntrada] = useState('');
  const [cliente, setCliente] = useState('');
  const [nome_cliente, setNomeCliente] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');
  const [observation, setObservation] = useState('');
  const [transshipment, setTransshipment] = useState(false);
  const [itens, setItens] = useState([]);
  const [itens_removidos, setItensRemovidos] = useState([]);
  const [id_total, setIdTotal] = useState('');
  const [base_calc_icms, setBaseCalcIcms] = useState('');
  const [valor_icms_total, setValorIcmsTotal] = useState('');
  const [valor_total_icms_subs, setValorTotalIcmsSubs] = useState('');
  const [base_calc_icms_subs, setBaseCalcIcmsSubs] = useState('');
  const [valor_total_produtos, setValorTotalProdutos] = useState('');
  const [valor_frete, setValorFrete] = useState('');
  const [valor_seguro, setValorSeguro] = useState('');
  const [desconto, setDesconto] = useState('');
  const [outras_despesas, setOutrasDespesas] = useState('');
  const [valor_total_ipi, setValorTotalIpi] = useState('');
  const [valor_total_doc, setValorTotalDoc] = useState('');
  const [showModalAuxiliariesData, setShowModalAuxiliariesData] = useState(false);
  const [id_transporte, setIdTransporte] = useState('');
  const [qtde_volumes, setQtdeVolumes] = useState('');
  const [especie, setEspecie] = useState('');
  const [peso_liquido, setPesoLiquido] = useState('');
  const [peso_bruto, setPesoBruto] = useState('');
  const [frete, setFrete] = useState('');
  const [transporte, setTransporte] = useState('');
  const [nome_transporte, setNomeTransporte] = useState('');
  const [cidade_transporte, setCidadeTransporte] = useState('');
  const [estado_transporte, setEstadoTransporte] = useState('');
  const [cpf_motorista, setCPFMotorista] = useState('');
  const [nome_motorista, setNomeMotorista] = useState('');
  const [placa_veiculo, setPlacaVeiculo] = useState('');
  const [origin, setOrigin] = useState('');

  const [ident_item, setIdentItem] = useState('new');
  const [sequencial_item, setSequencialItem] = useState('');
  const [id_item, setIdItem] = useState('');
  const [id_produto, setProduto] = useState('');
  const [tipo_produto, setTipoProduto] = useState('');
  const [descricao, setDescricao] = useState('');
  const [um, setUm] = useState('');
  const [quantidade, setQuantidade] = useState('');
  const [preco_unitario, setPrecoUnitario] = useState('');
  const [valor_total, setValorTotal] = useState('');
  const [aliquota_icms, setAliquotaIcms] = useState('');
  const [valor_icms, setValorIcms] = useState('');
  const [aliquota_ipi, setAliquotaIpi] = useState('');
  const [valor_ipi, setValorIpi] = useState('');
  const [lot, setLot] = useState("");
  const [palletLabel, setPalletLabel] = useState("");

  const [listUnidades, setListUnidades] = useState([]);
  const [listUnidadesProdutos, setListUnidadesProdutos] = useState([]);
  const [listFretes, setListFretes] = useState([]);
  const [listTiposProdutos, setListTipoProdutos] = useState([]);

  const [listSearchProducts, setListSearchProducts] = useState([]);
  const [listSearchCliente, setListSearchCliente] = useState([]);
  const [listSearchTransport, setListSearchTransport] = useState([]);
  
  const [currentItem, setCurrentItem] = useState(0);

  const [headerAuxiliaresDatas, setHeaderAuxiliaresDatas] = useState({
    processo: "",
    servico: "",
    lote: "",
    container: "",
    consolidado: ""
  });
  const [tableHeaders, setTableHeaders] = useState([
    {name: "#", validation: true, scope: 1},
    {name: "Produto", validation: true, scope: 1, isRequired: true},
    {name: "Tipo", validation: true, scope: 1},
    {name: "Unidade Medida", validation: true, scope: 1},
    {name: "Quantidade", validation: true, scope: 1, isRequired: true},
    {name: "Preço Unitário", validation: true, scope: 1, isRequired: true},
    {name: "Valor Total", validation: true, scope: 1},
    {name: "Alíquota ICMS", validation: true, scope: 1},
    {name: "Valor ICMS", validation: true, scope: 1},
    {name: "Alíquota IPI", validation: true, scope: 1},
    {name: "Valor IPI", validation: true, scope: 1},
    {name: "Lote", validation: true, scope: 1},
    {name: "Palete", validation: true, scope: 1},
    {name: "Opções", validation: true, scope: 1}
  ]);
  const [showModals, setShowModals] = useState({
    confirmDelete: false
  });
  const [infos, setInfos] = useState({
    data_emissao: "",
    data_entrada: ""
  });
  
  useEffect(()=> {
    async function loadUser(){
      if (id) {
        getOne(id, option);
      } else {
        setInfos((prevState) => ({...prevState, data_entrada: dateToday}));
        setHoraEntrada(hoursNow);
        setCarrying(false);
      }
    }

    getData();
    loadUser();

  },[]);

  function validItem() {
    if ((id_produto != '') && (quantidade != '') && (preco_unitario != '')) {
      return true;
    } else {
      toast.error('Preencha todos os campos com * para salvar o item!');
      return false;
    }
  }

  function validForm() {
    if ((transporte != '') && (nome_motorista != '') && (cpf_motorista != '') && (placa_veiculo != '') && (infos.data_emissao != '') && (numero_documento != '') && (serie_documento != '') && (cliente != '') && (itens.length > 0)) {
      return true;
    } else {
      toast.error('Preencha todos os campos com * para salvar o item!');
      return false;
    }
  }

  function save(e){
    setCarrying(true);
    e.preventDefault();
     
    if (!validForm()) {
      setCarrying(false);
      return false;
    }

    const data = {
      row: {
        emissao: emissao,
        tipo: tipo,
        complemento: complemento,
        numero_documento: numero_documento,
        serie_documento: serie_documento,
        especie_documento: especie_documento,
        data_emissao: infos.data_emissao,
        data_entrada: infos.data_entrada,
        hora_entrada: hora_entrada,
        cliente: cliente,
        cidade: cidade,
        estado: estado,
        observacao: observation,
      },
      itens: itens,
      itens_removidos: itens_removidos,
      transporte: {
        qtde_volumes: qtde_volumes,
        especie: especie,
        peso_liquido: peso_liquido,
        peso_bruto: peso_bruto,
        frete: frete,
        transporte: transporte,
        cidade: cidade_transporte,
        estado: estado_transporte,
        cpf_motorista: cpf_motorista,
        nome_motorista: nome_motorista,
        placa_veiculo: placa_veiculo,
      },
      total: {
        base_calc_icms: base_calc_icms,
        valor_icms: valor_icms_total,
        base_calc_icms_subs: base_calc_icms_subs,
        valor_total_produtos: valor_total_produtos,
        valor_total_icms_subs: valor_total_icms_subs,
        valor_frete: valor_frete,
        valor_seguro: valor_seguro,
        desconto: desconto,
        outras_despesas: outras_despesas,
        valor_total_ipi: valor_total_ipi,
        valor_total_doc: valor_total_doc,
      },
      dados_aux: currentItem,
      transbordo: transshipment
    }

    if (id) { 
      data.row.id = id;
      data.transporte.id = id_transporte;
      data.total.id = id_total;
      api.put("/api/entry_documents/put", data)
      .then((response) => {
          toast.success('Registro atualizado com sucesso.');
          history.push('/entry_documents');
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    } else {
      api.post("/api/entry_documents/post", data)
      .then((response) => {
          toast.success('Registro inserido com sucesso.');
          history.push('/entry_documents');
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function getOne(id, option){
    api.get("/api/entry_documents/getList?id=" + id)
    .then((response) => {
        setEmissao(response.data.row.emissao);
        setTipo(response.data.row.tipo);
        setComplemento(response.data.row.complemento);
        setNumeroDocumento(response.data.row.numero_documento);
        setSerieDocumento(response.data.row.serie_documento);
        setEspecieDocumento(response.data.row.especie_documento);
        setInfos((prevState) => ({...prevState, data_emissao: response.data.row.data_emissao, data_entrada: response.data.row.data_entrada}));
        setHoraEntrada(response.data.row.hora_entrada);
        setCliente(response.data.row.cliente);
        setNomeCliente(response.data.row.nome_cliente);
        setCidade(response.data.row.cidade);
        setEstado(response.data.row.estado);
        setObservation(response.data.row.observacao);
        setOrigin(response.data.row.origin);

        setItens(response.data.itens);

        setBaseCalcIcms(response.data.total.base_calc_icms);
        setValorIcmsTotal(response.data.total.valor_icms);
        setBaseCalcIcmsSubs(response.data.total.base_calc_icms_subs);
        setValorTotalIcmsSubs(response.data.total.valor_total_icms_subs);
        setValorTotalProdutos(response.data.total.valor_total_produtos);
        setValorFrete(response.data.total.valor_frete);
        setValorSeguro(response.data.total.valor_seguro);
        setDesconto(response.data.total.desconto);
        setOutrasDespesas(response.data.total.outras_despesas);
        setValorTotalIpi(response.data.total.valor_total_ipi);
        setValorTotalDoc(response.data.total.valor_total_doc);
        setIdTotal(response.data.total.id);

        setQtdeVolumes(response.data.transporte.qtde_volumes);
        setEspecie(response.data.transporte.especie);
        setPesoLiquido(response.data.transporte.peso_liquido);
        setPesoBruto(response.data.transporte.peso_bruto);
        setFrete(response.data.transporte.frete);
        setTransporte(response.data.transporte.transporte);
        setNomeTransporte(response.data.transporte.nome_transporte);
        setCidadeTransporte(response.data.transporte.cidade);
        setEstadoTransporte(response.data.transporte.estado);
        setIdTransporte(response.data.transporte.id);
        setCPFMotorista(response.data.transporte.cpf_motorista);
        setNomeMotorista(response.data.transporte.nome_motorista);
        setPlacaVeiculo(response.data.transporte.placa_veiculo);

        if(response.data.row.dados_aux){
          setHeaderAuxiliaresDatas(response.data.row.dados_aux);
        }

        setCarrying(false);
      }
    ).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });

    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/entry_documents');
  }

  function remove(){
    api.delete("/api/entry_documents/delete?id=" + id)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/entry_documents');
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  async function getData() {
    api.get("/api/entry_documents/getDataPage")
    .then((response) => {
      setListUnidades(response.data.unidades);
      setListTipoProdutos(response.data.tipos_produtos);
      setListFretes(response.data.fretes);
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  } 

  function searchClient(e) {
    api.get("/api/entry_documents/searchPeople?term=" + e.target.value.toLowerCase())
    .then((response) => {
      setListSearchCliente(response.data.people);
    }).catch((error) => {
      showMessageError(error.response.data);
    });
    setNomeCliente(e.target.value);
  }

  function searchTransportador(e) {
    api.get("/api/entry_documents/searchPeople?term=" + e.target.value.toLowerCase())
    .then((response) => {
      setListSearchTransport(response.data.people);
    }).catch((error) => {
      showMessageError(error.response.data);
    });
    setNomeTransporte(e.target.value);
  }

  async function selectTransport(item) {
    setTransporte(item.id);
    setNomeTransporte(item.nome);
    setCidadeTransporte(item.cidade);
    setEstadoTransporte(item.estado);
    
    setListSearchTransport([]);
  }

  async function selectClient(item) {
    setCliente(item.id);
    setNomeCliente(item.nome);
    setCidade(item.cidade);
    setEstado(item.estado);
    
    setListSearchCliente([]);
  }

  function inicializeItem() {
    setIdentItem('new');
    setSequencialItem('');
    setIdItem('');
    setProduto('');
    setDescricao('');
    setTipoProduto('');
    setUm('');
    setQuantidade('');
    setPrecoUnitario('');
    setValorTotal('');
    setAliquotaIcms('');
    setValorIcms('');
    setAliquotaIpi('');
    setValorIpi('');
  }

  function editItem(ident, item) {
    setIdentItem(ident);
    setSequencialItem(item.sequencial_item);
    setIdItem(item.id_item);
    setProduto(item.id_produto);
    setDescricao(item.descricao);
    setTipoProduto(item.tipo_produto);
    setUm(item.um);
    setQuantidade(item.quantidade);
    setPrecoUnitario(item.preco_unitario);
    setValorTotal(item.valor_total);
    setAliquotaIcms(item.aliquota_icms);
    setValorIcms(item.valor_icms);
    setAliquotaIpi(item.aliquota_ipi);
    setValorIpi(item.valor_ipi);

    setLabelButton('Salvar');
  }

  function removeItem(index) {
    let aux_itens = [];
    let aux_itens_removidos = itens_removidos;

    itens?.map((element, idx) => {
      if (idx == index) {
        aux_itens_removidos.push(element);
      } else {
        aux_itens.push(element);
      }
    });

    setItens(aux_itens);
    setItensRemovidos(aux_itens_removidos);

    inicializeItem();
  }

  function salvar() {
    if (!validItem()) {
      return false;
    }
    let aux_itens = itens;

    if (ident_item != 'new') {
      aux_itens[ident_item].id_item = id_item;
      aux_itens[ident_item].id_produto = id_produto;
      aux_itens[ident_item].descricao = descricao;
      aux_itens[ident_item].tipo_produto = tipo_produto;
      aux_itens[ident_item].um = um;
      aux_itens[ident_item].quantidade = quantidade;
      aux_itens[ident_item].preco_unitario = preco_unitario;
      aux_itens[ident_item].valor_total = valor_total;
      aux_itens[ident_item].aliquota_icms = aliquota_icms;
      aux_itens[ident_item].valor_icms = valor_icms;
      aux_itens[ident_item].aliquota_ipi = aliquota_ipi;
      aux_itens[ident_item].valor_ipi = valor_ipi;

    } else {
      const cont = aux_itens.length + 1;
      const data = {
        sequencial_item: cont,
        id_item: id_item,
        id_produto: id_produto,
        descricao: descricao,
        tipo_produto: tipo_produto,
        um: um,
        quantidade: quantidade,
        preco_unitario: preco_unitario,
        valor_total: valor_total,
        aliquota_icms: aliquota_icms,
        valor_icms: valor_icms,
        aliquota_ipi: aliquota_ipi,
        valor_ipi: valor_ipi,
      }

      aux_itens.push(data);
    }

    setItens(aux_itens);
    setLabelButton('Adicionar');
    inicializeItem();
  }

  function calcTotal() {
    if ((preco_unitario && preco_unitario != '') && (quantidade && quantidade != '')) {
      let aux_un = parseToFloat(preco_unitario);
      let aux_qtde = parseToFloat(quantidade);

      let total = aux_un * aux_qtde;

      setValorTotal(total.toString().replace('.',','));
    }
  }

  let delay;
  function searchProduct(e) {
    clearTimeout(delay);
    
    delay = setTimeout(() => {
      api.get("/api/entry_documents/searchProduct?term=" + e.target.value.toLowerCase())
      .then((response) => {
        setListSearchProducts(response.data.products);
      }).catch((error) => {
        showMessageError(error.response.data);
      });
    }, 1000);
    
    setDescricao(e.target.value);
  }

  function selectProduct(item) {
    api.get("/api/entry_documents/getSelectedProduct?id=" + item.id)
    .then((response) => {
      setProduto(response.data.id);
      setDescricao(response.data.descricao);
      setTipoProduto(response.data.id_tipo_produto);
      setUm(response.data.unidade_medida);
      
      setListUnidadesProdutos(response.data.units);
      setListSearchProducts([]);
    }).catch((error) => {
      console.log(error)
      showMessageError(error.response.data);
    });
  }
  
  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      <ModalConfirmation state={showModals.confirmDelete} setState={setShowModals} stateName={'confirmDelete'} custom={custom('500px', '250px')} title={'Deseja realmente excluir este documento?'} action={remove} param={''}/>
      <ModalAuxiliaresData
        showModalAuxiliariesData={{state: showModalAuxiliariesData, setState: setShowModalAuxiliariesData}}
        headerAuxiliaresDatas={{state: headerAuxiliaresDatas, setState: setHeaderAuxiliaresDatas}}
        itens={{state: itens, setItens}}
        origin={origin}
        view={view}
        currentItem={{state: currentItem, setState: setCurrentItem}}
        typeItens="entrada-documentos"
      />
            
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Entrada de Documentos">
          <Link to="/entry_documents">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Data de Emissão</label>&nbsp;<label className="required">*</label><br/>
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_emissao" disabled={(view || origin !== '' && origin !== '002')} />
                </div>
                <div className="formDiv">
                  <label>Número do Documento</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Número do Documento" value={numero_documento} onChange={ (e) => setNumeroDocumento(e.target.value) } maxLength="9" disabled={view || origin !== '' && origin !== '002'}/>
                </div>
                <div className="formDiv">
                  <label>Série do Documento</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Série do Documento" value={serie_documento} onChange={ (e) => setSerieDocumento(e.target.value) } maxLength="3" disabled={view || origin !== '' && origin !== '002'}/>
                </div>
              </div>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Cliente/Fornecedor</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Cliente/Fornecedor" value={nome_cliente} onChange={searchClient} maxLength="60" disabled={true}/>
                  <ul className="dropdown-menu" id="transportDatalist">
                    {listSearchCliente?.map((item, index) => (
                      <li key={index} onClick={() => selectClient(item)}>
                        <a>{item.nome}</a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="formDiv">
                  <label>Cidade</label><br/>
                  <input type="text" placeholder="Cidade" value={cidade} onChange={ (e) => setCidade(e.target.value) } maxLength="60" disabled={true}/>
                </div>
                <div className="formDiv">
                  <label>Estado</label><br/>
                  <input type="text" placeholder="Estado" value={estado} onChange={ (e) => setEstado(e.target.value) }  maxLength="60" disabled={true}/>
                </div>
              </div>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Data de Entrada</label><br/>
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_entrada" disabled />
                </div>
                <div className="formDiv">
                  <label>Hora de Entrada</label><br/>
                  <input type="text" placeholder="##:##:##" value={hora_entrada} onChange={ (e) => setHoraEntrada(setMaskHour(e.target.value, "##.##.##"))} maxLength="8" disabled={true}/>
                </div>
                <div className="formDiv">
                  <label>Observação</label><br/>
                  <input type="text" placeholder="Observação" value={observation} onChange={ (e) => setObservation(e.target.value)} maxLength="250" disabled={view || origin !== '' && origin !== '002'}/>
                </div>
                <div className="formDiv">
                <label>Transbordo</label><br/>
                  <select value={transshipment} onChange={(e) => setTransshipment(convertStringValueToBoolean(e.target.value))} disabled={view || origin !== '' && origin !== '002'}>                    
                    <option value={true}>Sim</option>
                    <option value={false}>Não</option>
                  </select>
                </div>
              </div>
            </div>
            <br />
            <div className="containerGroupData">
              <div className="divGroup">
                <div className="formDivListScroll">
                  <h2>Itens&nbsp;<label className="required">*</label></h2>
                  <hr style={{width: `${tableHeaders.filter((tableHeader) => tableHeader.validation).length * 150}px`}}></hr>
                  <table className="tableScroll">
                    <thead>
                      <tr>
                        {tableHeaders?.map((tableHeader, index) => {
                          if(tableHeader.validation){
                            return (
                              <th key={index} style={{width: "150px"}} className={tableHeader.name === "Opções" ? "collumOption" : ""} colSpan={tableHeader.scope}>{tableHeader.name}{tableHeader.isRequired && <>&nbsp;<label className="required">*</label></>}</th>
                            )
                          }
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {sequencial_item}
                        </td>
                        <td>
                          <div className="formDivRow">
                            <input type="text" placeholder="Produto" value={descricao} onChange={searchProduct} maxLength="60" disabled={view || origin !== '' && origin !== '002'}/>
                            <ul className="dropdown-menu" id="transportDatalist">
                              {listSearchProducts?.map((item, index) => (
                                <li key={index} onClick={() => selectProduct(item)}>
                                  <a>{item.descricao}</a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </td>
                        <td>
                          <div className="formDivRow">
                            <select value={tipo_produto} onChange={ (e) => setUm(e.target.value) } disabled={true}>
                              <option value="">Selecione</option>
                              {listTiposProdutos?.map((item, index) => (
                                <option key={index} value={item.id}>{item.descricao}</option>
                              ))}
                            </select>
                          </div>
                        </td>
                        <td>
                          <div className="formDivRow">
                            <select value={um} onChange={ (e) => setUm(e.target.value) } disabled={view || origin !== '' && origin !== '002'}>
                              <option value="">Selecione</option>
                              {listUnidadesProdutos?.map((item, index) => (
                                <option key={index} value={item.id}>{item.descricao}</option>
                              ))}
                            </select>
                          </div>
                        </td>
                        <td>
                          <div className="formDivRow">
                            <input type="text" placeholder="Quantidade" value={quantidade} onChange={ (e) => setQuantidade(setMaskDecimal(e.target.value, 4)) } onBlur={calcTotal} maxLength="16" disabled={view || origin !== '' && origin !== '002'}/>
                          </div>
                        </td>
                        <td>
                          <div className="formDivRow">
                            <input type="text" placeholder="Preço Unitário" value={preco_unitario} onChange={ (e) => setPrecoUnitario(setMaskDecimal(e.target.value, 4)) } onBlur={calcTotal} maxLength="20" disabled={view || origin !== '' && origin !== '002'}/>
                          </div>
                        </td>
                        <td>
                          <div className="formDivRow">
                            <input type="text" placeholder="Valor Total" value={valor_total} onChange={ (e) => setValorTotal(setMaskDecimal(e.target.value, 4)) } maxLength="20" disabled={true}/>
                          </div>
                        </td>
                        <td>
                          <div className="formDivRow">
                            <input type="text" placeholder="Alíquota ICMS" value={aliquota_icms} onChange={ (e) => setAliquotaIcms(setMaskDecimal(e.target.value, 2)) } maxLength="5" disabled={view || origin !== '' && origin !== '002'}/>
                          </div>
                        </td>
                        <td>
                          <div className="formDivRow">
                            <input type="text" placeholder="Valor Total" value={valor_icms} onChange={ (e) => setValorIcms(setMaskDecimal(e.target.value, 2)) } maxLength="14" disabled={view || origin !== '' && origin !== '002'}/>
                          </div>
                          </td>
                        <td>
                          <div className="formDivRow">
                            <input type="text" placeholder="Alíquota ICMS" value={aliquota_ipi} onChange={ (e) => setAliquotaIpi(setMaskDecimal(e.target.value, 2)) } maxLength="5" disabled={view || origin !== '' && origin !== '002'}/>
                          </div>
                        </td>
                        <td>
                          <div className="formDivRow">
                            <input type="text" placeholder="Valor Total" value={valor_ipi} onChange={ (e) => setValorIpi(setMaskDecimal(e.target.value, 2)) } maxLength="14" disabled={view || origin !== '' && origin !== '002'}/>
                          </div>  
                        </td>
                        <td>
                          <div className="formDivRow">
                            <input type="text" placeholder="Lote" value={lot} onChange={(e) => setLot(e.target.value)} maxLength="14" disabled={view || origin !== '' && origin !== '002'}/>
                          </div>  
                        </td>
                        <td>
                          <div className="formDivRow">
                            <input type="text" placeholder="Palete" value={palletLabel} onChange={(e) => setPalletLabel(e.target.value)} maxLength="14" disabled={view || origin !== '' && origin !== '002'}/>
                          </div>  
                        </td>
                        <td data-label="Opções">
                          <button type="button" className="buttonModalList" onClick={salvar} disabled={view}>{labelButton}</button>
                        </td>
                      </tr>
                      {itens?.map((item, index)=>{
                        return(
                          <tr key={index}>
                            <td>
                              {index + 1 }
                            </td>
                            <td data-label="Produto">{item.descricao}</td>
                            <td data-label="Produto">{viewItem(listTiposProdutos, item.tipo_produto)}</td>
                            <td data-label="Unidade Medida">{viewItem(listUnidades, item.um)}</td>
                            <td data-label="Quantidade">{item.quantidade}</td>
                            <td data-label="Preço Unitário">{item.preco_unitario}</td>
                            <td data-label="Valor Total">{item.valor_total}</td>
                            <td data-label="Alíquota ICMS">{item.aliquota_icms}</td>
                            <td data-label="Valor ICMS">{item.valor_icms}</td>
                            <td data-label="Alíquota IPI">{item.aliquota_ipi}</td>
                            <td data-label="Valor IPI">{item.valor_ipi}</td>
                            <td data-label="Lote">{item.lote}</td>
                            <td data-label="Etiqueta Palete">{item.etiqueta_palete}</td>
                            <td data-label="Opções">
                              <Link className="action" onClick={() => editItem(index, item)}>
                                <FaPen color="#000" size={17} />
                              </Link>
                              <Link className="action" onClick={() => removeItem(index)}>
                                <FaTrash color="#FFF" size={17} />
                              </Link>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>              
              </div>
            </div>
            <br />
            <div className="containerGroupData">
              <h2>Totais&nbsp;<label className="required">*</label></h2>
              <hr></hr>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Base de Cálculo do ICMS</label><br/>
                  <input type="text" placeholder="Base de Cálculo do ICMS" value={base_calc_icms} onChange={ (e) => setBaseCalcIcms(setMaskDecimal(e.target.value, 2)) } maxLength="18" disabled={view || origin !== '' && origin !== '002'}/>
                </div>

                <div className="formDiv">
                  <label>Valor do ICMS</label><br/>
                  <input type="text" placeholder="Valor do ICMS" value={valor_icms_total} onChange={ (e) => setValorIcmsTotal(setMaskDecimal(e.target.value, 2)) } maxLength="18" disabled={view || origin !== '' && origin !== '002'}/>
                </div>

                <div className="formDiv">
                  <label>Base de Cálculo do ICMS de Substituição</label><br/>
                  <input type="text" placeholder="Base de Cálculo do ICMS de Substituição" value={base_calc_icms_subs} onChange={ (e) => setBaseCalcIcmsSubs(setMaskDecimal(e.target.value, 2)) } maxLength="18" disabled={view || origin !== '' && origin !== '002'}/>
                </div>
                
                <div className="formDiv">
                  <label>Valor do ICMS Substituição</label><br/>
                  <input type="text" placeholder="Valor do ICMS Substituição" value={valor_total_icms_subs} onChange={ (e) => setValorTotalIcmsSubs(setMaskDecimal(e.target.value, 2)) } maxLength="18" disabled={view || origin !== '' && origin !== '002'}/>
                </div>

                <div className="formDiv">
                  <label>Valor Total dos Produtos</label><br/>
                  <input type="text" placeholder="Valor Total dos Produtos" value={valor_total_produtos} onChange={ (e) => setValorTotalProdutos(setMaskDecimal(e.target.value, 2)) } maxLength="18" disabled={view || origin !== '' && origin !== '002'}/>
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Valor do Frete</label><br/>
                  <input type="text" placeholder="Valor do Frete" value={valor_frete} onChange={ (e) => setValorFrete(setMaskDecimal(e.target.value, 2)) } maxLength="18" disabled={view || origin !== '' && origin !== '002'}/>
                </div>

                <div className="formDiv">
                  <label>Valor do Seguro</label><br/>
                  <input type="text" placeholder="Valor do Seguro" value={valor_seguro} onChange={ (e) => setValorSeguro(setMaskDecimal(e.target.value, 2)) } maxLength="18" disabled={view || origin !== '' && origin !== '002'}/>
                </div>

                <div className="formDiv">
                  <label>Desconto</label><br/>
                  <input type="text" placeholder="Desconto" value={desconto} onChange={ (e) => setDesconto(setMaskDecimal(e.target.value, 2)) } maxLength="18" disabled={view || origin !== '' && origin !== '002'}/>
                </div>

                <div className="formDiv">
                  <label>Outras Despesas</label><br/>
                  <input type="text" placeholder="Outras Despesas" value={outras_despesas} onChange={ (e) => setOutrasDespesas(setMaskDecimal(e.target.value, 2)) } maxLength="18" disabled={view || origin !== '' && origin !== '002'}/>
                </div>

                <div className="formDiv">
                  <label>Valor Total do IPI</label><br/>
                  <input type="text" placeholder="Valor Total do IPI" value={valor_total_ipi} onChange={ (e) => setValorTotalIpi(setMaskDecimal(e.target.value, 2)) } maxLength="18" disabled={view || origin !== '' && origin !== '002'}/>
                </div>
                
                <div className="formDiv">
                  <label>Valor Total do Documento</label><br/>
                  <input type="text" placeholder="Valor Total do Documento" value={valor_total_doc} onChange={ (e) => setValorTotalDoc(setMaskDecimal(e.target.value, 2)) } maxLength="18" disabled={view || origin !== '' && origin !== '002'}/>
                </div>
              </div>
            </div>
            <br />
            <div className="containerGroupData">
              <h2>Transporte&nbsp;<label className="required">*</label></h2>
              <hr></hr>
            
              <div className="divGroup">
                <div className="formDiv">
                  <label>Quantidade de Volumes</label><br/>
                  <input type="text" placeholder="Quantidade de Volumes" value={qtde_volumes} onChange={ (e) => setQtdeVolumes(setMaskDecimal(e.target.value, 0)) } maxLength="9" disabled={view || origin !== '' && origin !== '002'}/>
                </div>
                
                <div className="formDiv">
                  <label>Espécie</label><br/>
                  <select value={especie} onChange={ (e) => setEspecie(e.target.value) } disabled={view || origin !== '' && origin !== '002'} >
                    <option value="">Selecione</option>
                    {listUnidades?.map((item, index) => (
                      <option key={index} value={item.id}>{item.descricao}</option>
                    ))}
                  </select>
                </div>

                <div className="formDiv">
                  <label>Peso Líquido (kg)</label><br/>
                  <input type="text" placeholder="Peso Líquido" value={peso_liquido} onChange={ (e) => setPesoLiquido(setMaskDecimal(e.target.value, 3)) } maxLength="11" disabled={view || origin !== '' && origin !== '002'}/>
                </div>

                <div className="formDiv">
                  <label>Peso Bruto (kg)</label><br/>
                  <input type="text" placeholder="Peso Bruto" value={peso_bruto} onChange={ (e) => setPesoBruto(setMaskDecimal(e.target.value, 3)) } maxLength="11" disabled={view || origin !== '' && origin !== '002'}/>
                </div>
              </div>

              <div className="divGroup">              
                <div className="formDiv">
                  <label>Frete</label><br/>
                  <select value={frete} onChange={ (e) => setFrete(e.target.value) } disabled={view || origin !== '' && origin !== '002'} >
                    <option value="">Selecione</option>
                    {listFretes?.map((item, index) => (
                      <option key={index} value={item.chave}>{item.descricao}</option>
                    ))}
                  </select>
                </div>

                <div className="formDiv">
                  <label>Transportador</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Cliente/Fornecedor" value={nome_transporte} onChange={searchTransportador} maxLength="60" disabled={view || origin !== '' && origin !== '002'}/>
                  <ul className="dropdown-menu" id="transportDatalist">
                    {listSearchTransport?.map((item, index) => (
                      <li key={index} onClick={() => selectTransport(item)}>
                        <a>{item.nome}</a>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="formDiv">
                  <label>Cidade</label><br/>
                  <input type="text" placeholder="Cidade" value={cidade_transporte} onChange={ (e) => setCidade(e.target.value) } maxLength="60" disabled={true}/>
                </div>

                <div className="formDiv">
                  <label>Estado</label><br/>
                  <input type="text" placeholder="Estado" value={estado_transporte} onChange={ (e) => setEstado(e.target.value) }  maxLength="60" disabled={true}/>
                </div>
              </div>

              <div className="divGroup">
                <div className="formDiv">
                  <label>CPF do Motorista</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="CPF do Motorista" value={cpf_motorista} onChange={ (e) => setCPFMotorista(setMaskGeneric(e.target.value, '###.###.###-##')) } maxLength="14" disabled={view || origin !== '' && origin !== '002'} />
                </div>

                <div className="formDiv">
                  <label>Nome do Motorista</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Nome do Motorista" value={nome_motorista} onChange={ (e) => setNomeMotorista(e.target.value) } maxLength="60" disabled={view || origin !== '' && origin !== '002'} />
                </div>

                <div className="formDiv">
                  <label>Placa do Veículo</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Placa do Veículo" value={placa_veiculo} onChange={ (e) => setPlacaVeiculo(e.target.value) }  maxLength="10" disabled={view || origin !== '' && origin !== '002'} />
                </div>
              </div>

            </div>
            {!view && <div className="formDiv" style={{display: "flex", gap: "0.5rem"}}>
              {getPermission('OPERACOES - ENTRADA DOCUMENTOS - CADASTRO') && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              {id && getPermission('OPERACOES - ENTRADA DOCUMENTOS - EXCLUSAO') && <button type="button" className="buttonRemove" onClick={() => setShowModals((prevState) => ({...prevState, confirmDelete: true}))} disabled={view}>Excluir</button>}
              <button type="button" className="buttonTab" onClick={() => setShowModalAuxiliariesData(true)}>Dados auxiliares</button>
            </div>}
          </form>
        </div>
      </div>}
    </div>
  )
}